import _ from 'lodash-es';
import APIV5 from '~/models/api';
import { isCustomColumn } from '~/models/query';
import { Confirm } from '~/scripts/services/modal/modal';

export default class QueryClassesTreeController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 */
	constructor(
		$injector,
		$scope,
		$timeout,
		$translate,
		$uibModal,
	) {
		this.$injector = $injector;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;

		/** @type {any} */
		this.children = undefined;

		/** @type {any[]} */
		this.classes = [];

		/** @type {any} */
		this.data = undefined;

		/** @type {Function} */
		this.drop = () => null;

		/** @type {?import('../query-editor/query-editor.controller').default} */
		this.editor = null;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		/** @type {any} */
		this.parent = undefined;

		/** @type {?import('../query-classes/query-classes.controller').default} */
		this.queryClasses = null;
	}

	$onInit() {
		// injection du path
		if (!this.parent && this.classes && !this.children) {
			for (const c of this.classes) {
				c.path = [
					{
						inherits_extended: c.inherits_extended,
						kid:               c.node,
						name:              c.name,
						linker_kid:        c.linker_kid || '0',
						type:              c.type,
					},
				];
			}
		}

		if (this.data?.length > 0 && this.classes?.length === 0) {
			this.classes.push(...this.data);
		}

		if (!this.parent && this.ngModelCtrl) {
			this.ngModelCtrl.$validators.classRequired = modelValue => modelValue?.length > 0;
		}

		this.$scope.$watch('$ctrl.data', (newValue, oldValue) => {
			if ((oldValue === undefined || oldValue?.length === 0) && newValue?.length > 0) {
				this.classes.push(...this.data);
			}
			else if (oldValue?.length > 0 && (newValue === undefined || newValue?.length === 0)) {
				this.classes.length = 0;
				this.data = [];
			}
			this.ngModelCtrl?.$validate();
		}, true);
	}

	/**
	 *
	 * @param {any} c
	 */
	// eslint-disable-next-line class-methods-use-this
	async expand(c) {
		if (c.expanded) {
			c.expanded = false;
		}
		else {
			/** @type {any} */
			const options = {};

			if (this.parent) {
				options.parentid = this.parent.node;
			}
			try {
				/** @type {any} */
				const response = await APIV5.instance.mfChildren2(
					c.node,
					'QUERY',
					options,
					{ id: 'query-classes-tree.expand' },
				);
				c.expanded = true;
				c.classes = [];

				for (const child of response.result) {
					const path = _.cloneDeep(c.path) || [];
					if (path.length === 0) {
						path.push({
							kid:        c.node,
							name:       c.name,
							flow:       null,
							linker_kid: c.linker_kid,
							type:       c.type_kid,
						});
					}

					/** @type {any} */
					const p = {
						kid:        child.kid,
						name:       child.name,
						flow:       child.flow,
						linker_kid: child.linker_kid,
						type:       child.type_kid,
					};

					if ('linker_info' in child) {
						p.linker_info = {
							kid:  child.linker_info.kid,
							name: 'linker_info' in child ? child.linker_info.name : null,
						};
					}

					if ('class_kid' in child) {
						p.class_kid = child.class_kid;
					}

					if ('relation_kid' in child) {
						p.relation_kid = child.relation_kid;
					}

					path.push(p);

					/** @type {any} */
					const cl = {
						node:       child.kid,
						name:       child.name,
						linker_kid: child.linker_kid,
						type:       child.type_kid,
						formatter:  child.type,
						flow:       child.flow,
						selectable: child.selectable,
						children:   child.children,
						path,
						sep:        child.sep,
						parent:     c.node,
						classes: [],
						expanded: false,
					};
					if ('linker_info' in child) {
						cl.linker_info = {
							kid:  child.linker_info.kid,
							name: 'linker_info' in child ? child.linker_info.name : null,
						};
					}
					c.classes.push(cl);
				}
			}
			catch {
				c.expanded = false;
				c.classes = [];
			}
			this.$timeout(() => this.$scope.$apply());
		}
	}

	hasParent() {
		return this.parent;
	}

	/**
	 * @param {string} string_
	 * @returns {boolean}
	 */
	isCustomClass(string_) {
		return isCustomColumn(string_);
	}

	async remove() {
		const modal = new Confirm(this.$injector);
		const answer = await modal.open({
			title: this.$translate.instant('query.remove-class'),
			body: this.$translate.instant('query.remove-class-explanation'),
			accept: {
				label: this.$translate.instant('query.remove-class'),
				type: 'danger',
			},
		});

		if (answer) {
			this.classes.length = 0;
			this.data = undefined;
			this.$scope.$emit('query-class-deleteClass');
			if (this.editor) {
				await this.editor.reset();
			}
		}
	}
}
